import { ChevronDown } from 'lucide-react';
import { MutableRefObject, useRef, useState } from 'react';

import { clsx } from 'clsx';
import { useOnClickOutside } from 'usehooks-ts';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { SelectOptionType } from '@shared/types/global';

import cls from './DefaultSelect.module.scss';

type DefaultSelectProps = {
  options: SelectOptionType[];
  onChange: (value: SelectOptionType) => void;
  className?: string;
};

export const DefaultSelect = ({ options, onChange, className }: DefaultSelectProps) => {
  const wrapRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [open, setOpen] = useState(false);
  const currentValue = options.find((el) => el.active) || options[0];

  const toggleSelect = () => {
    setOpen(!open);
  };

  const onChangeHandler = (value: SelectOptionType) => {
    onChange(value);
    toggleSelect();
  };

  const closeSelect = () => {
    setOpen(false);
  };

  useOnClickOutside(wrapRef, closeSelect);

  const modes = {
    [cls.open]: open
  };

  return (
    <div
      data-testid={'select'}
      ref={wrapRef}
      className={clsx(cls.wrap, className, modes)}
    >
      <div className={cls.inner}>
        <div
          data-testid={'select-toggle'}
          onClick={toggleSelect}
          className={cls.currentValue}
        >
          <span>{currentValue.label}</span>
          <ChevronDown
            size={24}
            color={ICON_DEFAULT}
          />
        </div>
        <div className={cls.options}>
          {options.map((el, i) => (
            <div
              data-testid={'select-option'}
              key={i}
              onClick={() => onChangeHandler(el)}
              className={clsx(cls.option, {
                [cls.active]: el.active
              })}
            >
              <span>{el.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
